import { PartnerFlowValues } from "@remi/enums/partner-flow";
import { PartnerFlowToSource, type Source, SourceValues } from "@remi/types/source";

import type { User } from "../base";
import { partnerFlow } from "./partnerFlow";

export const source = {
  view: (user: User, source: Source): boolean => {
    return PartnerFlowValues.some((pf) => partnerFlow.view(user, pf) && PartnerFlowToSource[pf] === source);
  },
  viewable: (user: User): Source[] => {
    const set = new Set<Source>();
    for (const pf of PartnerFlowValues) {
      if (partnerFlow.view(user, pf)) {
        set.add(PartnerFlowToSource[pf]);
      }
    }
    const allowed = Array.from(set);
    return allowed.length > 0 ? allowed : [...SourceValues];
  },
};
